import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm, Controller } from "react-hook-form";
import * as Yup from "yup";
import { useSiteContext } from "../../contexts/SiteProvider";
import { MODULES_URLS } from "../../api/AdminUrls";
import { post } from "../../services/smartApiService";


interface HeaderProps {
  loadTableData: () => void;
  data: any;
}

// Validation Schema
const validationSchema = Yup.object({
  add_action: Yup.boolean(),
  edit_action: Yup.boolean(),
  view_action: Yup.boolean(),
  approve_action: Yup.boolean(),
});

const AdminModualForm: React.FC<HeaderProps> = ({ loadTableData, data }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: data,
  });
  const { openModal, closeModal } = useSiteContext();
  const onSubmit = (formData: any) => {
    let url = MODULES_URLS.INSERT;
    const id = data.ID;
    // console.log("id", id);

    const formattedData = {
      ...formData,
      add_action: formData.add_action ? "1" : "0",
      edit_action: formData.edit_action ? "1" : "0",
      view_action: formData.view_action ? "1" : "0",
      approve_action: formData.approve_action ? "1" : "0",
    };

    const subscription = post(url, { ...formattedData, id }).subscribe(() => {
      loadTableData(); 
      closeModal();
    });

    return () => subscription.unsubscribe();
  };

  return (
    <div className="box sd-efl-input">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="field">
          <div className="is-flex is-flex-wrap-wrap">
            {(["add_action", "edit_action", "view_action", "approve_action"] as const).map(
              (action) => (
                <div key={action} className="control ml-2 mb-2">
                  <label className="checkbox is-flex is-align-items-center">
                    <Controller
                      name={
                        action as "add_action" | "edit_action" | "view_action" | "approve_action"
                      }
                      control={control}
                      render={({ field }) => (
                        <input
                          type="checkbox"
                          checked={field.value == "1" ? true : false}
                          onChange={(e) => field.onChange(e.target.checked)}
                          ref={field.ref}
                          className="mr-2 "
                          style={{ width: "16px", height: "16px" }}
                        />
                      )}
                    />
                    {action
                      .replace("_", " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </label>
                </div>
              )
            )}
          </div>
        </div>

        <div className="has-text-right">
          <button type="submit" className="button smart-action-button">
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminModualForm;
